(function () {
  'use strict';
  var CFG = window.IKIDO_CRO || {};
  var THRESHOLD = CFG.freeShipThreshold || 10000;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BASE = ROOT.replace(/\/$/, '');
  var FSB_ON = !(window.Shopify && Shopify.country) || Shopify.country === 'CA';

  function money(cents) { return '$' + (Math.abs(cents) / 100).toFixed(2); }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }

  function injectStyles() {
    if (document.getElementById('ikido-cro-css')) return;
    var s = document.createElement('style');
    s.id = 'ikido-cro-css';
    s.textContent = [
      '.ikido-fsb{padding:14px 16px 6px;font-size:1.3rem;}',
      '.ikido-fsb__msg{margin:0 0 8px;text-align:center;line-height:1.3;}',
      /* Dawn hides every empty div (div:empty{display:none}), so the track and fill need an explicit display. */
      '.ikido-fsb .ikido-fsb__track{display:block;height:8px;border-radius:999px;background:rgba(var(--color-foreground,26,26,26),.12);overflow:hidden;}',
      '.ikido-fsb .ikido-fsb__fill{display:block;width:0;height:100%;border-radius:999px;background:rgb(var(--color-foreground,26,26,26));transition:width .6s ease,background-color .3s ease;}',
      '.ikido-fsb--done{color:#1a7f37;}',
      '.ikido-fsb.ikido-fsb--done .ikido-fsb__fill{background:#1a7f37;}',
      '.ikido-trust{display:flex;flex-wrap:wrap;gap:8px 18px;justify-content:center;padding:14px 16px;border-top:1px solid rgba(var(--color-foreground,26,26,26),.08);}',
      '.ikido-trust__item{display:flex;align-items:center;gap:6px;font-size:1.15rem;line-height:1.2;opacity:.8;}',
      '.ikido-trust__item svg{width:16px;height:16px;flex:0 0 auto;}',
      '.ikido-upsell{padding:14px 16px;border-top:1px solid rgba(var(--color-foreground,26,26,26),.08);}',
      '.ikido-upsell__title{font-size:1.3rem;font-weight:600;margin:0 0 10px;}',
      '.ikido-upsell__row{display:grid;grid-template-columns:repeat(2,1fr);gap:12px;}',
      '.ikido-upsell__card{font-size:1.15rem;text-decoration:none;color:inherit;}',
      '.ikido-upsell__card img{width:100%;aspect-ratio:1;object-fit:cover;border-radius:6px;display:block;margin-bottom:6px;}',
      '.ikido-upsell__name{display:block;line-height:1.25;margin-bottom:2px;}',
      '.ikido-upsell__price{opacity:.75;}',
      '.ikido-satc{position:fixed;left:0;right:0;bottom:0;z-index:9997;display:none;align-items:center;gap:12px;padding:10px 14px;background:rgb(var(--color-background,255,255,255));box-shadow:0 -2px 16px rgba(0,0,0,.14);}',
      '.ikido-satc.is-visible{display:flex;}',
      '.ikido-satc__info{flex:1;min-width:0;}',
      '.ikido-satc__title{display:block;font-size:1.3rem;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.ikido-satc__price{font-size:1.25rem;opacity:.8;}',
      '.ikido-satc__btn{flex:0 0 auto;border:0;border-radius:var(--buttons-radius,4px);padding:12px 22px;font-size:1.4rem;font-weight:600;background:rgb(var(--color-button,26,26,26));color:rgb(var(--color-button-text,255,255,255));cursor:pointer;}',
      '@media(min-width:750px){.ikido-satc{display:none !important;}}'
    ].join('');
    document.head.appendChild(s);
  }

  var ICON = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/></svg>',
    ret: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 8h11a5 5 0 0 1 0 10H9"/><path d="M7 5 4 8l3 3"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>',
    store: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 9l1-4h14l1 4M5 9v10h14V9M4 9h16"/></svg>'
  };
  function trustHTML() {
    function b(i, l) { return '<span class="ikido-trust__item">' + ICON[i] + '<span>' + l + '</span></span>'; }
    return '<div class="ikido-trust">' + b('truck', 'Ships from Toronto') + b('ret', '30-day returns') + b('lock', 'Secure checkout') + (FSB_ON ? b('store', 'Free Toronto pickup') : '') + '</div>';
  }

  /* Progress toward free shipping: the fill grows with the cart total and turns green at the threshold. */
  function fsbState(total) {
    var remaining = THRESHOLD - total;
    return {
      done: remaining <= 0,
      pct: total >= THRESHOLD ? 100 : Math.max(4, Math.min(100, Math.round(total / THRESHOLD * 100))),
      msg: remaining > 0 ? ("You're <strong>" + money(remaining) + "</strong> away from free shipping") : "You've unlocked <strong>free shipping</strong>"
    };
  }
  function fsbHTML() {
    return '<div class="ikido-fsb"><p class="ikido-fsb__msg"></p><div class="ikido-fsb__track" role="progressbar" aria-label="Progress to free shipping" aria-valuemin="0" aria-valuemax="100"><div class="ikido-fsb__fill"></div></div></div>';
  }
  /* Updates the bar in place so the width animates from its last value instead of jumping. */
  function setFsb(node, total) {
    var st = fsbState(total);
    node.classList.toggle('ikido-fsb--done', st.done);
    node.querySelector('.ikido-fsb__msg').innerHTML = st.msg;
    node.querySelector('.ikido-fsb__track').setAttribute('aria-valuenow', String(st.pct));
    var fill = node.querySelector('.ikido-fsb__fill');
    requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = st.pct + '%'; }); });
  }

  var recsCache = {};
  var rendering = false;

  function targets() {
    var out = [];
    var d = document.querySelector('#CartDrawer .drawer__footer'); if (d) out.push({ root: d, mode: 'full' });
    var p = document.querySelector('#main-cart-footer .cart__footer'); if (p) out.push({ root: p, mode: 'full' });
    var links = document.querySelector('#cart-notification .cart-notification__links');
    if (links && links.parentNode) out.push({ root: links.parentNode, before: links, mode: 'bar' });
    return out;
  }

  function clearExtras(root) {
    ['.ikido-fsb', '.ikido-upsell', '.ikido-trust'].forEach(function (s) {
      var n = root.querySelector(':scope > ' + s);
      if (n) n.remove();
    });
  }

  function renderInto(t, cart) {
    var root = t.root;
    if (!cart || cart.item_count === 0) { clearExtras(root); return; }
    var fsb = root.querySelector(':scope > .ikido-fsb');
    /* Free shipping over the threshold is a Canada-only offer, so the bar only shows to Canadian shoppers. */
    if (!FSB_ON) { if (fsb) fsb.remove(); }
    else if (!fsb) {
      fsb = el(fsbHTML());
      if (t.before && t.before.parentNode === root) { root.insertBefore(fsb, t.before); }
      else { root.insertBefore(fsb, root.firstChild); }
    }
    if (FSB_ON) setFsb(fsb, cart.total_price);
    if (t.mode !== 'full') return;

    var trust = root.querySelector(':scope > .ikido-trust');
    if (!trust) { trust = el(trustHTML()); root.appendChild(trust); }

    var ups = root.querySelector(':scope > .ikido-upsell');
    if (!ups) {
      ups = el('<div class="ikido-upsell" hidden><p class="ikido-upsell__title">You may also like</p><div class="ikido-upsell__slot"></div></div>');
      root.insertBefore(ups, trust);
    }
    var pid = cart.items && cart.items[0] && cart.items[0].product_id;
    if (pid) fillUpsell(ups, pid); else ups.hidden = true;
  }

  function fillUpsell(ups, pid) {
    if (ups.getAttribute('data-pid') === String(pid)) return;
    var slot = ups.querySelector('.ikido-upsell__slot');
    function apply(html) {
      if (!html) { ups.hidden = true; return; }
      slot.innerHTML = html;
      ups.hidden = false;
      ups.setAttribute('data-pid', String(pid));
    }
    if (recsCache[pid] !== undefined) { apply(recsCache[pid]); return; }
    var url = BASE + '/recommendations/products?section_id=ikido-cro-recs&intent=related&limit=4&product_id=' + pid;
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var row = '';
      try {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var found = doc.querySelector('.ikido-upsell__row');
        if (found && found.children.length) row = found.outerHTML;
      } catch (e) {}
      recsCache[pid] = row;
      apply(row);
    }).catch(function () { recsCache[pid] = ''; apply(''); });
  }

  function renderCart() {
    var ts = targets();
    if (!ts.length) return;
    fetch(BASE + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        rendering = true;
        ts.forEach(function (t) { try { renderInto(t, cart); } catch (e) {} });
        setTimeout(function () { rendering = false; }, 0);
      }).catch(function () {});
  }

  function watch() {
    ['#CartDrawer', '#main-cart-footer', '#cart-notification'].forEach(function (sel) {
      var node = document.querySelector(sel);
      if (!node) return;
      var t;
      new MutationObserver(function () {
        if (rendering) return;
        clearTimeout(t);
        t = setTimeout(renderCart, 150);
      }).observe(node, { childList: true, subtree: true });
    });
  }

  function productTitle() {
    var h = document.querySelector('.product__title h1, .product__title h2');
    if (h) return h.textContent.trim();
    var t = document.querySelector('.product__title');
    return t ? t.textContent.trim().split('\n')[0].trim() : '';
  }

  function stickyATC() {
    var realBtn = document.querySelector('.product-form__submit');
    if (!realBtn || !document.querySelector('.product__title') || document.querySelector('.ikido-satc')) return;
    function priceText() {
      var p = document.querySelector('.product .price__sale .price-item--sale, .product .price__regular .price-item--regular, .product .price .price-item, .price .price-item');
      return p ? p.textContent.trim() : '';
    }
    var bar = el('<div class="ikido-satc"><div class="ikido-satc__info"><span class="ikido-satc__title"></span> <span class="ikido-satc__price"></span></div><button type="button" class="ikido-satc__btn">Add to cart</button></div>');
    bar.querySelector('.ikido-satc__title').textContent = productTitle();
    bar.querySelector('.ikido-satc__price').textContent = priceText();
    bar.querySelector('.ikido-satc__btn').addEventListener('click', function () { realBtn.click(); });
    document.body.appendChild(bar);
    try {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -60px 0px' }).observe(realBtn);
    } catch (e) { bar.classList.add('is-visible'); }
    document.addEventListener('change', function () {
      setTimeout(function () { bar.querySelector('.ikido-satc__price').textContent = priceText(); }, 80);
    });
  }

  function init() { injectStyles(); renderCart(); watch(); stickyATC(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
